<div *ngIf="this.errors.length != 0" class="boxedValidation">
  <b>Please review the following fields:</b>
  <div class="labelMargin"></div>
  <li class="errorText" *ngFor="let error of errors;">
    {{error}}
  </li>
</div>
